/**
 * Language of the shader code
 */
export const enum ShaderLanguage {
    /** language is GLSL (used by WebGL) */
    GLSL,
    /** language is WGSL (used by WebGPU) */
    WGSL,
}
